import { getAllQueryParamsInURL } from '@pulse/common';
import { PageInfoService } from './page-info.service';

export interface UTMParams {
    utm_source?: string;
    utm_campaign?: string;
    utm_medium?: string;
    utm_term?: string;
    utm_content?: string;
}

export class UTMTrackerService {
    constructor(private page: PageInfoService) {}

    getUTMParams(): UTMParams | undefined {
        const url = new URL(getAllQueryParamsInURL(this.page.landingPageUrl()));

        const utm_source = url.searchParams.get('utm_source');
        const utm_medium = url.searchParams.get('utm_medium');
        const utm_campaign = url.searchParams.get('utm_campaign');
        const utm_term = url.searchParams.get('utm_term') || '';
        const utm_content = url.searchParams.get('utm_content') || '';

        if (utm_source || utm_campaign) {
            return {
                utm_source: utm_source || undefined,
                utm_medium: utm_medium || undefined,
                utm_campaign: utm_campaign || undefined,
                utm_term: utm_term || undefined,
                utm_content: utm_content || undefined,
            };
        }

        return undefined;
    }
}
